<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.kecelakaanKerja }}</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #waktu-filter>
                <date-picker style="width: 100%" v-model="filter.waktu" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #namaStatusKronologiKecelakaan-filter>
                <b-form-select v-model="filter.statusKronologiKecelakaan" :options="statusKronologiKecelakaan"></b-form-select>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button
                    variant="warning"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                    v-b-modal.modal-edit
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    @click="data = item"
                  >
                    <CIcon name="cil-pencil" />
                  </b-button>
                  <b-button
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                    v-b-modal.modal-delete
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    @click="data = item"
                  >
                    <CIcon name="cil-trash" />
                  </b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-input :karyawan="karyawan" @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" :karyawan="karyawan" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";
export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  name: "kecelakaanKerja",
  data() {
    return {
      edit: false,
      data: {},
      karyawan: [],
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "waktu",
          label: "Tanggal - Jam Kecelakaan Kerja",
          _style: "max-width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: "Nama Karyawan",
          _style: "maax-width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "lokasiKecelakaan",
          label: "Lokasi Kejadian",
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaStatusKronologiKecelakaan",
          label: "Status",
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ],
      filter: {
        waktu: null,
        statusKronologiKecelakaan: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      statusKronologiKecelakaan: [
        { value: null, text: "Pilih" },
        { value: "Aksiden", text: "Aksiden" },
        { value: "Insiden", text: "Insiden" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
  },
  mounted() {
    if (this.$store.state.role_aktif.kodeRole == "super") {
      this.fields.splice(1, 0, {
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      });
    }
    this.getDatas();
    this.getKaryawan();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.statusKronologiKecelakaan"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.waktu"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  // waktuKecelakaan, statusKronologiKecelakaan
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listKecelakaanKerja = await vm.$axios.post("/kecelakaanKerja/listPerHalaman", {
        ...vm.filter,
        waktuKecelakaan: vm.filter.waktu ? vm.$moment(vm.filter.waktu).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      console.log("listKecelakaanKerja", listKecelakaanKerja);
      vm.items = [];
      vm.items =
        listKecelakaanKerja.data.status == 200
          ? listKecelakaanKerja.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.kecelakaanKerjaId,
                namaMitra: x.namaMitra || " - ",
                namaStatusKronologiKecelakaan: x.statusKronologiKecelakaan,
                waktu: vm.$moment(x.waktuKecelakaan).format("LL - kk:mm"),
                //edit
                dataKaryawanIdEdit: { dataKaryawanId: x.dataKaryawanId, namaNIK: `${x.namaKaryawan} - ${x.NIK}` },
              };
            })
          : [];
      vm.totalRows = parseInt(listKecelakaanKerja.data.count);
      vm.loading = false;
    },
    async getKaryawan() {
      let vm = this;
      let listKaryawan = await vm.$axios.get("/dataKaryawan/list");
      vm.karyawan =
        listKaryawan.data.status == 200
          ? listKaryawan.data.data.map((x) => {
              return {
                ...x,
                namaNIK: `${x.namaKaryawan} - ${x.NIK}`,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
